export default __webpack_public_path__ + "static/media/CV-LUCIA-MIGUES.036ec81f.pdf";